<script setup lang="ts">
/**
 * CaHalamanLegal — kerangka bersama tiga halaman kebijakan v3
 * (/privasi, /syarat, /refund).
 *
 * Halaman kebijakan adalah halaman yang paling sering dipakai orang untuk
 * memutuskan apakah sebuah situs pantas dipercaya dengan uang dan KTP-nya.
 * Karena itu kerangkanya dibuat satu: judul, tanggal berlaku, kalimat
 * pembuka, lalu isi berupa kartu-kartu — bukan tiga tata letak yang mirip
 * tapi tidak sama.
 *
 * Lebarnya dikunci ke --container-ca-narrow (720px): teks kebijakan dibaca
 * baris demi baris, dan baris sepanjang 1120px melelahkan.
 */
defineProps<{
  judul: string
  /** Tanggal berlaku, mis. TANGGAL_KEBIJAKAN. */
  terakhir: string
  ikon?: string
}>()
</script>

<template>
  <div>
    <section class="relative overflow-hidden">
      <div class="ca-aura" aria-hidden="true" />

      <div class="relative mx-auto w-full max-w-[var(--container-ca-narrow)] px-4 sm:px-6 pt-8 sm:pt-12 pb-8">
        <CaRemah :jejak="[['Beranda', '/'], [judul, '']]" />

        <CaBadge v-if="ikon" tone="netral" :icon="ikon" class="mt-5">Ketentuan resmi</CaBadge>

        <h1 class="ca-h1 mt-4 text-ink text-balance">{{ judul }}</h1>

        <p class="ca-caption text-muted mt-3 flex items-center gap-1.5">
          <UIcon name="i-lucide-calendar-check" class="size-4 shrink-0" aria-hidden="true" />
          <span>Terakhir diperbarui: {{ terakhir }}</span>
        </p>

        <p class="mt-5 text-lg text-muted leading-relaxed">
          <slot name="pembuka" />
        </p>
      </div>
    </section>

    <section class="ca-tunda pb-14 sm:pb-20">
      <div class="mx-auto w-full max-w-[var(--container-ca-narrow)] px-4 sm:px-6">
        <div class="flex flex-col gap-4 sm:gap-5">
          <slot />
        </div>

        <div class="mt-9">
          <CaSeparator />
          <p class="ca-caption text-muted mt-5">
            Baca juga:
            <slot name="tautan" />
          </p>
        </div>
      </div>
    </section>
  </div>
</template>
